import React, { useState, useEffect } from "react";
import { Container, Form, Button, Alert, Card, InputGroup } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNotification } from "../context/NotificationContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const { login, user } = useAuth();
  const { notify } = useNotification();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const loginUrl = `${process.env.REACT_APP_API_URL}/auth/login`;

      const response = await fetch(loginUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Login failed");
      }

      const data = await response.json();

      const success = login(data.token, data.refreshToken);
      if (!success) {
        notify("Invalid login credentials.", "danger");
        return;
      }
      navigate("/");
    } catch (err) {
      setError(err.message || "Failed to connect to server");
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center auth-container auth-bg">
      <Card className="shadow p-4 border-0 auth-card">
        <h2 className="text-center fw-bold mb-3 section-heading">Login</h2>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-3">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="shadow-sm"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <InputGroup>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="shadow-sm"
              />
              <Button
                variant="outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </Button>
            </InputGroup>
          </Form.Group>

          <div className="text-end mb-3">
            <Link to="/reset-password" className="text-decoration-none" style={{ fontSize: "0.85rem" }}>
              Forgot password?
            </Link>
          </div>

          <Button variant="primary" type="submit" className="w-100 fw-bold shadow-sm">
            Login
          </Button>
        </Form>

        <div className="text-center mt-3">
          <small className="text-muted">
            Don't have an account?{" "}
            <Link to="/register" className="text-decoration-none">Register here</Link>
          </small>
        </div>
      </Card>
    </Container>
  );
};

export default Login;
